import { Component, HostListener, OnInit, ViewChildren, QueryList, ElementRef, Output, EventEmitter, ChangeDetectorRef, ViewChild } from '@angular/core';

import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { SchoolData } from 'src/app/models/schoolUser';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BookingService } from 'src/app/services/api/booking.service';
import { CommonService } from 'src/app/services/api/common.service';
import { NgxUiLoaderService } from "ngx-ui-loader"; // Import NgxUiLoaderService
import { ToastrService } from 'ngx-toastr';
import moment from 'moment';
import { InlineCalendarComponent } from '../inline-calendar/inline-calendar.component';
import { ValidatedDictComponent } from '../validated-dict/validated-dict.component';
import { NgClass, NgIf, NgFor, CommonModule } from '@angular/common';
import { JsonPipe } from '@angular/common';
import { QldProfileCompletionComponent } from "../../consumer/profile/qld-profile-completion/qld-profile-completion.component";
import { SafeUrlPipe } from '../school-profile/safe-url.pipe';
import { VideoPlayerComponent } from '../../../shared/video-player/video-player.component';

@Component({
  selector: 'app-teacher-profile-popup',
  templateUrl: './teacher-profile-popup.component.html',
  styleUrls: ['./teacher-profile-popup.component.scss'],

  standalone: true,
  imports: [CommonModule, NgClass, ValidatedDictComponent, NgIf, InlineCalendarComponent, NgFor, FormsModule, ReactiveFormsModule, VideoPlayerComponent, JsonPipe, QldProfileCompletionComponent, SafeUrlPipe]
})
export class TeacherProfilePopupComponent implements OnInit {
  public schoolProps!: SchoolData;
  title?: string;
  closeBtnName?: string;
  teacher: any;
  href: any;
  from: any;
  invite_sent: any;
  remainingInvites: any
  Invitedteacher: any;
  job_id: any;
  inlineEndDate: any;
  IsPrint: boolean = false;
  showPrintStatus: boolean = false;
  monthsShown: any;
  school_id: any;
  @ViewChild('resendPendingInviteModal') resendPendingInviteModal: any;

  inviteToJobForm: FormGroup = this.fb.group({
    job_id: [''],
    teacher_id: [''],
    custom_message: ['']
  });
  nextPrevForm: FormGroup = this.fb.group({
    providerId: [''],
    dateStart: [''],
    dateTime: ['']
  });
  dateList: any;
  date: any;
  inlineEndDateTeacherModal: any;
  introVideo: any = null;

  constructor(public bsModalRef: BsModalRef,
    private _router: Router,
    private route: ActivatedRoute,
    private modalService: BsModalService,
    private fb: FormBuilder,
    private bookingService: BookingService,
    private ngxService: NgxUiLoaderService,
    private toastr: ToastrService) {
    this.inlineEndDate = moment(new Date()).format('DD/MM/YYYY');
  }

  ngOnInit() {
    this.href = this._router.url.split('?')[0];
    this.schoolProps = JSON.parse(localStorage.getItem("userData") || '{}');
    const videoIntroDetails = this.teacher?.meta?.video_intro_details;
    if (videoIntroDetails?.video_intro_link) {
      const ytId = this.getYouTubeId(videoIntroDetails.video_intro_link);
      if (ytId) {
        this.introVideo = {
          type: 'youtube',
          id: ytId,
          url: videoIntroDetails.video_intro_link,
          title: videoIntroDetails.video_intro_title || '',
          thumbnail: videoIntroDetails.video_intro_thumbnail || '',
          duration: videoIntroDetails.video_intro_duration || null,
        };
      } else {
        // Could add Vimeo support here if needed
        const vimeoId = this.getVimeoId(videoIntroDetails.video_intro_link);
        if (vimeoId) {
          this.introVideo = {
            type: 'vimeo',
            id: vimeoId,
            url: videoIntroDetails.video_intro_link,
            title: videoIntroDetails.video_intro_title || '',
            thumbnail: videoIntroDetails.video_intro_thumbnail || '',
            duration: videoIntroDetails.video_intro_duration || null,
          };
        } else {
          this.introVideo = null;
        }
      }
    } else {
      this.introVideo = null;
    }
  }
  openInviteModal(teacher: any) {
    this.bsModalRef.hide()
    this.Invitedteacher = teacher
    this.bsModalRef = this.modalService.show(this.resendPendingInviteModal, { class: 'modal-md', backdrop: 'static' });
  }
  getInviteJobFormControlValue() {
    return this.inviteToJobForm.value
  }
  // Helper: parse YouTube ID
  private getYouTubeId(url: string): string | null {
    const match = url.match(/(?:youtu\.be\/|youtube\.com\/(?:shorts\/|embed\/|v\/|live\/|watch\?v=|watch\?.+&v=))([\w-]{11})/);
    return match ? match[1] : null;
  }

  // Helper: parse Vimeo ID
  private getVimeoId(url: string): string | null {
    const match = url.match(/(?:vimeo\.com\/(?:video\/)?)(\d+)/);
    return match ? match[1] : null;
  }
  inviteToJob(teacher: any) {
    this.ngxService.start();
    this.inviteToJobForm.patchValue({
      job_id: this.job_id,
      teacher_id: teacher.id.toString()
    })

    this.bsModalRef.hide();
    this.bookingService.inviteJob(this.getInviteJobFormControlValue()).subscribe({
      next: (res: any) => {
        this.inviteToJobForm.patchValue({
          custom_message: ''
        })
        if (res.status) {
          this.toastr.success(res.message);
          let currentUrl = "school/jobs/headhunter";
          this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this._router.navigate([currentUrl], { queryParams: { jobId: this.job_id } });
          });
        } else {
          this.toastr.error(res.message);
          this.ngxService.stop();
        }
      },
      error: (err: any) => {
        alert("error")
        console.log(err);
        this.toastr.error(err.message);
        this.ngxService.stop()
      }
    });

  }

  public setArrData(data: any): void {
    console.log(data);
  }

  printSection(event?: Event) {
    // Prevent modal from closing by stopping event propagation if called from a button
    event?.stopPropagation();
    this.showPrintStatus = true;
    // this.ngxService.start();

    setTimeout(() => {
      const printArea = document.getElementById('printArea');
      if (!printArea) {
        this.showPrintStatus = false;
        // this.ngxService.stop();
        return;
      }

      const clone = printArea.cloneNode(true) as HTMLElement;

      const tabPanes = clone.querySelectorAll('.tab-pane');
      tabPanes.forEach((pane: Element) => {
        pane.classList.remove('fade', 'show');
        pane.classList.add('active');
        pane.setAttribute('style', 'display:block');
      });

      const navTabs = clone.querySelector('.nav-tabs');
      if (navTabs) navTabs.parentNode?.removeChild(navTabs);

      const styles = Array.from(document.querySelectorAll('link[rel="stylesheet"], style'))
        .map((node) => node.outerHTML)
        .join('\n');

      const printWindow = window.open('', '', 'height=800,width=1200');
      if (printWindow) {
        printWindow.document.head.innerHTML = `<title>Print</title>${styles}`;
        printWindow.document.body.innerHTML = clone.innerHTML;
        printWindow.document.close();
        printWindow.focus();

        // Listen for print dialog close
        const resetStatus = () => {
          this.showPrintStatus = false;
          // this.ngxService.stop();
          printWindow.removeEventListener('afterprint', resetStatus);
          printWindow.close();
        };

        printWindow.addEventListener('afterprint', resetStatus);

        setTimeout(() => {
          printWindow.print();
        }, 500);
      } else {
        this.toastr.error('Unable to open print window. Please check your browser settings.');
        this.showPrintStatus = false;
        // this.ngxService.stop();
      }
    }, 100);
  }

  nextFortnight() {
    this.setPrevNxtData(this.inlineEndDate, true, 1);
  }

  prevFortnight() {
    this.setPrevNxtData(this.inlineEndDate, true, 2);
  }
  setPrevNxtData(res: any, apiCall: boolean, sendDate: number) {
    this.inlineEndDateTeacherModal = res;

    // Set Next Prev Api Call
    if (apiCall) {
      // this.ngxService.start();
      //  1 for nextfortnight
      //  2 for previousfortnight

      if (sendDate == 1) {
        let nxtPrevDate = this.addDays(this.inlineEndDateTeacherModal)
        // this.findNewFilterForm.patchValue({
        //   date: nxtPrevDate,
        // });
        this.date = nxtPrevDate;

      } else if (sendDate == 2) {
        let nxtPrevDate = this.substractDays(this.inlineEndDateTeacherModal)
        // this.findNewFilterForm.patchValue({
        //   date: nxtPrevDate,
        //   // filter_date:nxtPrevDate
        // });
        this.date = nxtPrevDate;

      }
      console.log(this.date);
      // let apiDate = sendDate == 1 ? this.inlineEndDate : sendDate == 2 ? this.addDays(this.inlineEndDate) : this.substractDays(this.inlineEndDate);

      // let nxtPrevDate = { 'date': apiDate };
      // console.log(nxtPrevDate);
      const payload = {
        providerId: [this.teacher.id],
        date: this.date
      }

      this.bookingService.nextPrevFortAPI(payload).subscribe({
        next: (res: any) => {
          console.log(res);
          this.monthsShown = res.data.months_shown;
          // this.bsValue = this.formatSameDate(this.inlineEndDate);
          this.ngxService.stop();
        },
        error: (err: any) => {
          console.log(err);
          this.ngxService.stop();
        }
      })
    }
  }
  getFilterFormControlValues(arg0: string): any {
    throw new Error('Method not implemented.');
  }

  addDays(date: any) {
    var currentDate = date;
    var momentObj = moment(currentDate, 'DD/MM/YYYY');
    return momentObj.add(14, 'd').format('DD/MM/YYYY')
  }

  substractDays(date: any) {
    var currentDate = date;
    var momentObj = moment(currentDate, 'DD/MM/YYYY');
    return momentObj.subtract(14, 'd').format('DD/MM/YYYY')
  }


}
